import React from "react";
import classes from "./Cart.module.scss";

const Cart = props => {
  // const cartItems = <ul>{[{
  //   id: 1,
  //   name: 'Bottoms',
  //   quatity: 2,
  //   price: 2555
  // },{
  //   id: 2,
  //   name: 'Crop Top',
  //   quantity: 1,
  //   price: 9999
  // }].map(item => <li>{item.name}</li>)}</ul>;

  // return <div>
  // {CartItems}
  //   <div></div>
  //   <div></div>
  // </div>
  return <h1>Welcome to cart!</h1>
}

export default Cart;